import { request } from "../../utils/request";
import { versionfn } from "../../utils/version";
var version = versionfn.version;

// AI画布上图接口
export function aiConvertGraph(data) {
  return request({
    url: `${version}/address/analysis/aiConvertGraph`,
    method: "post",
    headers: {
      "Content-Type": "application/json", // 指定为JSON格式
    },
    data,
  });
}
//获取工具分析信息
export function toolApi(data) {
  return request({
    url: `${version}/ai/conversation/tool`,
    method: "post",
    headers: {
      "Content-Type": "application/json", // 指定为JSON格式
    },
    data,
  });
}
// 会话记录
export function conversationLog(data) {
  return request({
    url: `${version}/ai/conversation/log`,
    method: "post",
    data,
  });
}
// 会话记录明细
export function conversationLogDetail(conversationId) {
  return request({
    url: `${version}/ai/conversation/log/${conversationId}`,
    method: "get",
  });
}
// 保存ai画布
export function saveAiCanvases(data) {
  return request({
    url: `${version}/manage/ai/canvases`,
    method: "post",
    data,
  });
}
// 新增会话记录明细评论
export function addComment(data) {
  return request({
    url: `${version}/ai/conversation/log/detail/addComment`,
    method: "post",
    data,
  });
}
//编辑会话记录明细评论(只支持好评改差评)
export function editComment(data) {
  return request({
    url: `${version}/ai/conversation/log/detail/editComment`,
    method: "post",
    data,
  });
}
//取消会话明细评价
export function cancelComment(data) {
  return request({
    url: `${version}/ai/conversation/log/detail/cancelComment`,
    method: "post",
    data,
  });
}
// 差评问题选项数据
export function badCommentOptions() {
  return request({
    url: `${version}/ai/conversation/log/detail/comment/problems`,
    method: "get",
  });
}
// oss授权
export function oss() {
  return request({
    url: `oss/authority?business=ai-canvas-conversation-comment`,
    method: "get",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": "*",
    },
  });
}
//oss授权文件
export function ossfile() {
  return request({
    url: `/oss/authority?business=tag-file`,
    method: "get",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": "*",
    },
  });
}
